import { getObjectLabels } from '@paintscout/util/builder'
import React from 'react'
import type { Activity } from '@paintscout/api'
import Highlight from '@paintscout/ui/components/Highlight'
import { useClientOptions } from '../../providers/ClientOptionsProvider'

export default function QuoteLabel(props: { activity: Activity }) {
  const { activity } = props
  const { options } = useClientOptions()
  const objectLabels = getObjectLabels({ options })

  const isInvoice = !!activity.details.invoice

  let label
  if (isInvoice) {
    label = 'Invoice'
  } else {
    label = objectLabels.quote.value
  }

  return <Highlight>{label}</Highlight>
}
